export default {"src":"/_next/static/media/note.be3821b5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};